var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlameSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 1.5C6.33333 2.83333 7 3.91667 8 4.75C9 5.58333 9.5 6.5 9.5 7.5C9.5 8.42826 9.13125 9.3185 8.47487 9.97487C7.8185 10.6313 6.92826 11 6 11C5.07174 11 4.1815 10.6313 3.52513 9.97487C2.86875 9.3185 2.5 8.42826 2.5 7.5C2.5 6.95907 2.67544 6.43274 3 6C3 6.33152 3.1317 6.64946 3.36612 6.88388C3.60054 7.1183 3.91848 7.25 4.25 7.25C4.58152 7.25 4.89946 7.1183 5.13388 6.88388C5.3683 6.64946 5.5 6.33152 5.5 6C5.5 5 4.75 4.5 4.75 3.5C4.75 2.83333 5.16667 2.16667 6 1.5Z",
    stroke: "var(--stroke-0, #FF6900)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlameSmall);
export default __webpack_public_path__ + "static/media/icon-flame-small.b8be131721c2e03f1377a0140a97946d.svg";
export { ForwardRef as ReactComponent };